import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {Image} from '@app/components/Image';

export const Fraud: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['remuneration']});
	return (
		<LandingIllustrationSection
			description={
				<>
					<Image
						priority
						aspectRatio="516/363"
						maxW={{base: '285px'}}
						sizes="50vw"
						src="94380f1559f611cf76a3d65b76702d7b.png"
						alt="fraud"
					/>
					<LandingHeading as="h2" maxWidth="550px">
						{t('acpslandingpage_title_reducingfraud_standalone-web')}
					</LandingHeading>
					<LandingParagraph
						maxWidth="550px"
						color="text.neutral.primary.default"
					>
						{t('acpslandingpage_text_reducingfraud_standalone-web')}
					</LandingParagraph>
				</>
			}
		/>
	);
};
